(function () {
  var config = window.__quantityBundle;
  if (!config) return;

  var customLabel    = config.label || 'unit';
  var mostPopularQty = config.mostPopularQty;
  var defaultQty     = config.defaultQty;
  var innerObserver  = null;
  var patching       = false;
  var userInteracted = false;
  var lastWidget     = null;

  function pluralize(qty, label) {
    if (qty === 1) return label;
    if (/[^aeiou]y$/i.test(label)) return label.replace(/y$/i, 'ies');
    if (/(s|sh|ch|x|z)$/i.test(label)) return label + 'es';
    return label + 's';
  }

  function patchLabels() {
    var textEls = document.querySelectorAll('.bndlr-quantity-break .bndlr-text');
    textEls.forEach(function (el) {
      var match = el.textContent.match(/(\d+)/);
      var qty   = match ? parseInt(match[1], 10) : 1;
      el.textContent = el.textContent.replace(/\bunits?\b/gi, pluralize(qty, customLabel));
    });
  }

  function selectRadio(input) {
    var proto = window.HTMLInputElement.prototype;
    var nativeSetter = Object.getOwnPropertyDescriptor(proto, 'checked').set;
    nativeSetter.call(input, true);
    input.dispatchEvent(new Event('click', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function setDefaultSelection(widget) {
    if (userInteracted) return;
    var inputs = widget.querySelectorAll('input[type="radio"]');
    if (inputs.length === 0) return;

    inputs.forEach(function (r) {
      r.setAttribute('autocomplete', 'off');
    });

    var targetInput = inputs[0];

    if (defaultQty && defaultQty > 0) {
      for (var i = 0; i < inputs.length; i++) {
        if (parseInt(inputs[i].value, 10) === defaultQty) {
          targetInput = inputs[i];
          break;
        }
      }
    }

    for (var j = 0; j < inputs.length; j++) {
      if (inputs[j] !== targetInput && inputs[j].checked) {
        inputs[j].checked = false;
      }
    }

    if (!targetInput.checked) {
      selectRadio(targetInput);
    }

    widget.querySelectorAll('.bndlr-radio-container').forEach(function (c) {
      c.setAttribute('data-bundler-break-active', c.contains(targetInput) ? 'true' : 'false');
    });
  }

  function patchBadges() {
    var containers = document.querySelectorAll('.bndlr-quantity-break .bndlr-radio-container');
    containers.forEach(function (container) {
      var existing = container.querySelector('.bndlr-most-popular-badge');
      var input    = container.querySelector('input[type="radio"]');
      var qty      = input ? parseInt(input.value, 10) : null;

      if (qty === mostPopularQty) {
        if (!existing) {
          var badge = document.createElement('span');
          badge.className   = 'bndlr-most-popular-badge';
          badge.textContent = 'Most Popular';
          container.appendChild(badge);
        }
      } else {
        if (existing) existing.remove();
      }
    });
  }



  function patchLayout(widget) {
    var containers = widget.querySelectorAll('.bndlr-radio-container');
    var count = containers.length;
    if (count === 0) return;
    widget.setAttribute('data-bundle-count', count);

    widget.style.setProperty('display', 'grid', 'important');
    widget.style.setProperty('gap', '10px', 'important');

    if (count > 3) {
      widget.classList.add('bndlr-layout-grid-2', 'bndlr-bundle-more');
      widget.classList.remove('bndlr-layout-row', 'bndlr-bundle-1', 'bndlr-bundle-2', 'bndlr-bundle-3');
      widget.style.setProperty('grid-template-columns', 'repeat(2, 1fr)', 'important');
    } else {
      widget.classList.add('bndlr-layout-row', 'bndlr-bundle-' + count);
      widget.classList.remove('bndlr-layout-grid-2', 'bndlr-bundle-more');
      widget.style.setProperty('grid-template-columns', 'repeat(' + count + ', 1fr)', 'important');
    }

    containers.forEach(function (c) {
      c.style.setProperty('min-width', '0', 'important');
      c.style.setProperty('width', '100%', 'important');
      c.style.setProperty('max-width', '100%', 'important');
      c.style.setProperty('margin', '0', 'important');
      c.style.setProperty('box-sizing', 'border-box', 'important');
    });
  }

  function patchAll(widget) {
    if (patching) return;
    patching = true;

    if (innerObserver) innerObserver.disconnect();

    patchLayout(widget);
    patchLabels();
    patchBadges();
    setDefaultSelection(widget);

    if (innerObserver) {
      innerObserver.observe(widget, { childList: true, subtree: true });
    }

    patching = false;
  }

  function bindClicks(widget) {
    widget.addEventListener('click', function (e) {
      if (!e.isTrusted) return;
      var container = e.target.closest('.bndlr-radio-container');
      if (container) {
        userInteracted = true;
        var radio = container.querySelector('input[type="radio"]');
        if (radio && !radio.checked) {
          selectRadio(radio);
        }
        widget.querySelectorAll('.bndlr-radio-container').forEach(function (c) {
          c.setAttribute('data-bundler-break-active', c === container ? 'true' : 'false');
        });
      }
    });

    widget.addEventListener('keydown', function (e) {
      if (!e.isTrusted) return;
      if (e.key === 'Enter' || e.key === ' ') {
        var container = e.target.closest('.bndlr-radio-container');
        if (container) {
          e.preventDefault();
          var radio = container.querySelector('input[type="radio"]');
          if (radio) {
            userInteracted = true;
            selectRadio(radio);
            widget.querySelectorAll('.bndlr-radio-container').forEach(function (c) {
              c.setAttribute('data-bundler-break-active', c === container ? 'true' : 'false');
            });
          }
        }
      }
    });
  }

  /**
   * Recalculate and update every price tier in the Bundler widget.
   * @param {string|number} variantId  - new Shopify variant ID
   * @param {number}        priceCents - new variant price in Shopify cents
   */
  function updateBundlerPrices(variantId, priceCents) {
    var widget = document.querySelector('.bndlr-quantity-break');
    if (!widget) return;

    widget.setAttribute('data-variant-id', variantId);

    var moneyFormat = (document.body && document.body.getAttribute('data-money-format')) || '{{amount}}';
    var fmt = (window.Shopify && window.Shopify.formatMoney)
      ? function (cents) { return window.Shopify.formatMoney(cents, moneyFormat); }
      : function (cents) { return (cents / 100).toFixed(2); };

    widget.querySelectorAll('.bndlr-radio-container').forEach(function (container) {
      var radio = container.querySelector('input[type="radio"]');
      if (!radio) return;

      var qty = parseInt(radio.value, 10) || 1;

      var discountPct = 0;
      var savingsEl = container.querySelector('.bndlr-savings-text');
      if (savingsEl) {
        var m = savingsEl.textContent.match(/(\d+(?:\.\d+)?)\s*%/);
        if (m) discountPct = parseFloat(m[1]);
      }

      var originalCents   = priceCents * qty;
      var discountedCents = Math.round(originalCents * (1 - discountPct / 100));

      var discountedSpan = container.querySelector('.bndlr-discounted-price');
      if (discountedSpan) {
        var fmtD = fmt(discountedCents);
        discountedSpan.textContent = fmtD;
        discountedSpan.setAttribute('data-currentprice', discountedCents);
        discountedSpan.setAttribute('data-currency-gbp', fmtD);
      }

      var originalSpan = container.querySelector('.bndlr-original-price');
      if (originalSpan) {
        var fmtO = fmt(originalCents);
        originalSpan.textContent = fmtO;
        originalSpan.setAttribute('data-currentprice', originalCents);
        originalSpan.setAttribute('data-currency-gbp', fmtO);
      }
    });
  }

  document.addEventListener('variant:change', function (e) {
    if (!e.detail) return;

    var variantId  = e.detail.variantId;
    var priceCents = null;

    if (e.detail.variant && typeof e.detail.variant.price === 'number') {
      priceCents = e.detail.variant.price;
    }

    if (priceCents === null) {
      var sel = document.querySelector('select[name="id"]');
      if (sel) {
        var opt = sel.querySelector('option[value="' + variantId + '"]');
        if (opt) priceCents = parseInt(opt.getAttribute('data-price-cents'), 10);
      }
    }

    if (variantId && priceCents !== null && !isNaN(priceCents)) {
      updateBundlerPrices(variantId, priceCents);
    }
  });

  // ---------------------------------------------------------------------------

  var outerObserver = new MutationObserver(function () {
    var widget = document.querySelector('.bndlr-quantity-break');
    if (widget) {
      if (widget !== lastWidget) {
        lastWidget = widget;
        patchAll(widget);
        bindClicks(widget);
        setTimeout(function () { if (!userInteracted) setDefaultSelection(widget); }, 350);

        if (innerObserver) innerObserver.disconnect();
        innerObserver = new MutationObserver(function () {
          patchAll(widget);
        });
        innerObserver.observe(widget, { childList: true, subtree: true });
      }
    }
  });

  outerObserver.observe(document.body, { childList: true, subtree: true });

  // Initial check in case it's already in the DOM
  var existingWidget = document.querySelector('.bndlr-quantity-break');
  if (existingWidget) {
    lastWidget = existingWidget;
    patchAll(existingWidget);
    bindClicks(existingWidget);
    setTimeout(function () { if (!userInteracted) setDefaultSelection(existingWidget); }, 350);

    if (innerObserver) innerObserver.disconnect();
    innerObserver = new MutationObserver(function () {
      patchAll(existingWidget);
    });
    innerObserver.observe(existingWidget, { childList: true, subtree: true });
  }
})();